import { render, staticRenderFns } from "./CompareCriterions.vue?vue&type=template&id=0928f747&scoped=true"
import script from "./CompareCriterions.vue?vue&type=script&lang=js"
export * from "./CompareCriterions.vue?vue&type=script&lang=js"
import style0 from "./CompareCriterions.vue?vue&type=style&index=0&id=0928f747&prod&lang=css"
import style1 from "./CompareCriterions.vue?vue&type=style&index=1&id=0928f747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928f747",
  null
  
)

export default component.exports